import { type ReactNode } from 'react'

import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import { ButtonRoot, type Props as RootProps } from '../ButtonRoot/ButtonRoot'

import styles from './ButtonText.module.scss'

type Props = {
  children: ReactNode
  colorScheme?: 'light' | 'dark' | 'surface' | 'warning'
  disabled?: boolean
  fontNormal?: boolean
  hover?: 'accent' | 'primary' | 'warning' | 'none'
  size?: 'sm' | 'lg'
  textshadow?: boolean
  underlined?: boolean
} & DistributiveOmit<RootProps, 'className'>

export const ButtonText = ({
  children,
  colorScheme,
  fontNormal,
  hover,
  size,
  textshadow,
  underlined,
  ...props
}: Props) => (
  <ButtonRoot
    className={cn(styles.container, {
      colorScheme,
      disabled: props.disabled,
      fontNormal,
      hover,
      size,
      styles,
      textshadow,
      underlined,
    })}
    {...props}
  >
    {children}
  </ButtonRoot>
)
